import i18n from 'i18nextInstance';

export const downloadHeaders = [{
    key: 'user_last_name',
    label: i18n.t('Apellido')
}, {
    key: 'user_first_name',
    label: i18n.t('Nombre')
}, {
    key: 'user_identification',
    label: i18n.t('DNI')
}, {
    key: 'user_gender',
    label: i18n.t('Sexo')
}, {
    key: 'user_email',
    label: i18n.t('Email')
}, {
    key: 'user_cellphone_number',
    label: i18n.t('Teléfono')
}, {
    key: 'user_type',
    label: i18n.t('Usuario')
}, {
    key: 'created_at',
    label: i18n.t('Fecha')
}, {
    key: 'quality',
    label: i18n.t('Calidad')
}, {
    key: 'session',
    label: i18n.t('Sesión')
}, {
    key: 'comments',
    label: i18n.t('Comentarios')
}, {
    key: 'audio',
    label: i18n.t('Audio')
}, {
    key: 'video',
    label: i18n.t('Video')
}, {
    key: 'call_id',
    label: i18n.t('Llamada')
}];
